import { BackLink, Intro, Loader } from "components/commons";
import { Path, Portal, Role } from "enums";
import locale from "localization";
import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import { UserContext } from "contexts";
import { formatAmount, formatVolume } from "utils";
import AccountTypeVipTiersTable from "../account-type-vip-tiers/account-type-vip-tiers-table";
import {
  FieldKind,
  formatByKind,
  isEmptyValue,
  useAccountTypeGroupTiers,
} from "../account-type-vip-tiers/account-type-vip-tiers.utils";
import styles from "./account-type-vip-view.module.scss";

const ViewAccountTypeVipModule = (props) => {
  const history = useHistory();
  const accountTypeId = props.location.state ? props.location.state.accountTypeId : "";
  const { user } = useContext(UserContext);
  const { role } = user?.userAccesses?.find((element) => element.portal === Portal.LOCQ);

  const { loading, groupLabel, tiers } = useAccountTypeGroupTiers(accountTypeId);

  return (
    <div>
      <BackLink text={locale.accountTypes} path={Path.AccountTypes} />
      <div className={styles.intro}>
        {role === Role.Accounting ? (
          <Intro title={locale.viewAccountType} titleStyle={styles.title} />
        ) : (
          <Intro
            title={locale.viewAccountType}
            actionText={locale.edit}
            actionOnClick={() => {
              history.push(Path.EditAccountType, { accountTypeId });
            }}
            actionOutlined
            actionClassName={styles.primaryEditButton}
            actionStartIcon={<span className="icon-pencil" />}
            titleStyle={styles.title}
          />
        )}
      </div>

      <Loader open={loading} />
      {!loading && tiers.length > 0 && (
        <AccountTypeVipTiersTable
          groupLabel={groupLabel}
          columns={tiers.map((tier) => ({ ...tier, key: tier.accountTypeId }))}
          renderHeader={(tier) => tier.name || tier.tierCode || "--"}
          renderField={(tier, fieldKey, kind) => {
            const value = tier[fieldKey];
            if (isEmptyValue(value)) {
              return "--";
            }
            if (kind === FieldKind.Amount) {
              return formatAmount(value);
            }
            if (kind === FieldKind.Volume) {
              return formatVolume(value);
            }
            if (kind === FieldKind.VolumeRate) {
              return `${formatByKind(value, kind)} L`;
            }
            return formatByKind(value, kind);
          }}
        />
      )}
    </div>
  );
};

export default ViewAccountTypeVipModule;
